import { c as _c } from "react/compiler-runtime";
import { useDeviceType } from '@libs/common-next';
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps } from './types';
import './Tile6UpVisualNav.scss';
export default function Tile6UpVisualNav(t0) {
  const $ = _c(8);
  const {
    tiles,
    header,
    className,
    overrideDefaultClass
  } = t0;
  const {
    isMobile
  } = useDeviceType();
  const classNameType = !isMobile && tiles.length < 6 ? "xl-even-spacing" : "";
  const t1 = `${className || "tile6up-visual-nav"} ${classNameType}`;
  let t2;
  if ($[0] !== overrideDefaultClass) {
    t2 = {
      overrideDefaultClass
    };
    $[0] = overrideDefaultClass;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      960: {
        perView: 5,
        gap: 16
      },
      560: {
        perView: 3.5,
        gap: 8
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== header || $[4] !== t1 || $[5] !== t2 || $[6] !== tiles) {
    t4 = <BuildContextProvider><SixTileCarousel header={header} className={t1} {...t2} alignText="center" data-testid="six-tile-visual-nav" tiles={tiles} variant="VisualNav" breakpoints={t3} /></BuildContextProvider>;
    $[3] = header;
    $[4] = t1;
    $[5] = t2;
    $[6] = tiles;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}